module.exports = __webpack_public_path__ + "img/support-white.243c0dbf.svg";